module.exports = __webpack_public_path__ + "static/media/PTA交流広場.91c699c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/PTA交流広場.png
// module id = 302
// module chunks = 10